// Wraps Office.js callbacks as promises.
export function getCurrentItem() {
    const item = Office.context.mailbox?.item;
    if (!item)
        return null;
    // We only support read-mode messages in v1 (manifest enforces it).
    return item;
}
function isPdfAttachment(name, contentType) {
    return (contentType === 'application/pdf' ||
        contentType === 'application/x-pdf' ||
        name.toLowerCase().endsWith('.pdf'));
}
export function listAttachments() {
    const item = getCurrentItem();
    if (!item?.attachments)
        return [];
    return item.attachments
        .filter((a) => !a.isInline)
        .map((a, i) => {
        const name = a.name || a.attachmentName || `Attachment ${i + 1}`;
        const contentType = a.contentType || 'application/octet-stream';
        return { id: a.id, name, contentType, size: a.size ?? 0, isInline: a.isInline };
    })
        .filter((a) => isPdfAttachment(a.name, a.contentType));
}
export function getAttachmentBytes(attachmentId) {
    return new Promise((resolve, reject) => {
        const item = getCurrentItem();
        if (!item)
            return reject(new Error('No mail item open'));
        item.getAttachmentContentAsync(attachmentId, (result) => {
            if (result.status !== Office.AsyncResultStatus.Succeeded) {
                return reject(new Error(result.error.message));
            }
            const content = result.value;
            if (content.format === Office.MailboxEnums.AttachmentContentFormat.Base64) {
                const bin = atob(content.content);
                const bytes = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++)
                    bytes[i] = bin.charCodeAt(i);
                resolve(bytes.buffer);
            }
            else {
                reject(new Error(`Unsupported attachment format: ${content.format}`));
            }
        });
    });
}
export function getItemMeta() {
    const item = getCurrentItem();
    if (!item)
        return null;
    return {
        subject: item.subject,
        from: item.from?.emailAddress,
        fromName: item.from?.displayName,
    };
}
